import { useQueryClient } from '@tanstack/react-query';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { useNotifications } from '../../context/notifications-context';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useMarkReadAll = ({
  companyId,
  onSuccess,
}: {
  companyId: string;
  onSuccess?: () => void;
}) => {
  const queryClient = useQueryClient();
  const { handleReadAllNotification } = useNotifications();
  const { mutate: markAllAsRead } = useAppMutation(
    [QueryKey.MARK_NOTIFICATION_AS_READ, companyId],
    {
      mutationFn: () =>
        ApiService.post({
          endpoint: BackendRoute.COMPANIES,
          routePath: [companyId, 'notifications', 'mark-read-all'],
        }),
      onSuccess: () => {
        handleReadAllNotification();
        onSuccess?.();
        queryClient.invalidateQueries({ queryKey: [QueryKey.GET_UNREAD_NOTIFICATION_COUNT] });
        queryClient.invalidateQueries({ queryKey: [QueryKey.GET_NOTIFICATIONS] });
      },
    },
  );

  return {
    markAllAsRead,
  };
};
